export default function registerHistoryStackDirective(Alpine) {
  const activeModals = new Map();

  let isSystemAction = false;

  Alpine.directive("historyStack", (el, { expression }, { effect }) => {
    const varName = expression;

    effect(() => {
      const data = Alpine.$data(el);

      const isOpen = data[varName];

      if (isOpen) {
        if (!activeModals.has(el)) {
          history.pushState({ hasModal: true }, "");

          activeModals.set(el, varName);
        }

        return;
      }

      if (!activeModals.has(el)) return;

      if (!isSystemAction && window.history.state?.hasModal) {
        history.back();
      }

      activeModals.delete(el);
    });
  });

  window.addEventListener("popstate", () => {
    isSystemAction = true;

    const entries = Array.from(activeModals.entries());

    if (entries.length > 0) {
      const [lastEl, lastVar] = entries[entries.length - 1];

      Alpine.$data(lastEl)[lastVar] = false;
    }

    setTimeout(() => {
      isSystemAction = false;
    }, 0);
  });
}
